const MENU_ITEMS = [
    {
      key: "dashboards",
      label: "Dashboards",
      isTitle: false,
      icon: "airplay",
      url: "/",
    },
    {
      key: "master",
      label: "Master",
      isTitle: false,
      icon: "airplay",
      children: [
        {
          key: "master-users",
          label: "Users",
          url: "/Users",
          parentKey: "master",
        },
        {
          key: "master-state",
          label: "State",
          url: "/State",
          parentKey: "master",
        },
        {
          key: "master-city",
          label: "City",
          url: "/City",
          parentKey: "master",
        },
        {
          key: "master-geofence",
          label: "Geofence",
          url: "/Geofence",
          parentKey: "master",
        },
        
      ],
    },
    {
      key: "hospital-master",
      label: "Hospital Master",
      isTitle: false,
      icon: "list",
      children: [
        {
          key: "hospital",
          label: "Hospital",
          url: "/Hospital",
          parentKey: "hospital-master",
        },
      ],
    },
    
  ];
  
  export { MENU_ITEMS };
  